import React, { useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import Seo from '../components/Seo';
import { useI18n } from '../i18n/I18nContext';
import { useAuth } from './AuthContext';
import './Auth.css';

const Login = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { login } = useAuth();
  const { t } = useI18n();
  const [form, setForm] = useState({ email: '', password: '' });
  const [error, setError] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const updateForm = (key, value) => {
    setForm((current) => ({ ...current, [key]: value }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError('');
    setSubmitting(true);
    try {
      await login(form);
      navigate(searchParams.get('next') || '/account');
    } catch {
      setError(t('auth.login.error'));
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <main className="auth-page">
      <Seo
        title={t('header.login')}
        description={t('auth.login.seoDescription')}
        path="/login"
        noindex
      />
      <section className="auth-card">
        <h1>{t('header.login')}</h1>
        <p>{t('auth.login.intro')}</p>
        <form className="auth-form" onSubmit={handleSubmit}>
          <label>
            {t('common.email')}
            <input
              type="email"
              value={form.email}
              onChange={(event) => updateForm('email', event.target.value)}
              autoComplete="email"
              required
            />
          </label>
          <label>
            {t('common.password')}
            <input
              type="password"
              value={form.password}
              onChange={(event) => updateForm('password', event.target.value)}
              autoComplete="current-password"
              required
            />
          </label>
          {error && <div className="auth-error">{error}</div>}
          <button type="submit" disabled={submitting}>
            {submitting ? t('auth.login.submitting') : t('header.login')}
          </button>
        </form>
        <div className="auth-switch">
          {t('auth.login.newUser')} <Link to={`/register${searchParams.get('next') ? `?next=${encodeURIComponent(searchParams.get('next'))}` : ''}`}>{t('auth.createAccount')}</Link>
        </div>
      </section>
    </main>
  );
};

export default Login;
